/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Service
 *
 * 1 = Investigation
 *
 * 2 = Recall
 *
 * 3 = Repair
 *
 * 4 = MOT
 */
export enum BookingType {
  Service = 0,
  Investigation = 1,
  Recall = 2,
  Repair = 3,
  MOT = 4,
}
